import React from 'react';

export const Contact = () => {
  return (
    <div>
      This is the contact page.
    </div>
  )
}